/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import moment from "moment";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { Container, CustomLabel, GridGroup } from "./styles";
import { InputText } from "../../../ui/inputs";
import { LabSelect } from "../../../components/course/select";
import { ButtonPrimary } from "../../../ui/buttons";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { configDatePickerLenguage } from "../../../components/RelevosInfoGeneral/utils";
import useFetcher from "../../../hooks/useFetcher";
import { fetchSucursales } from "../../../services/sucursalServices";
import { formatearFecha } from "../../../components/CandidatosNP/utils";
import { createRegistroDeVisita, updateRegistroDeVisita } from "../../../services/clientesServices";
import { handleErrors } from "../../../services/handleErrors";

const MotivosOptions = [
  { value: "Visita", label: "Visita" },
  { value: "Relevo", label: "Relevo" },
  { value: "TBD", label: "TBD" },
];

export const createOrUpdateVisita = async (data, id) => {
  if (id) {
    const res = await updateRegistroDeVisita(id, data);
    return res;
  }
  const res = await createRegistroDeVisita(data);
  return res;
};

export default function RegistroDeVisitasForm({ clientId, razonSocial, toggle, refreshVisitas, dataToEdit }) {
  const locale = configDatePickerLenguage();
  const fechaActual = moment().format("YYYY-MM-DD");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [fechaValue, setFechaValue] = useState(fechaActual);
  const [motivoValue, setMotivoValue] = useState(null);
  const [sucursalValue, setSucursalValue] = useState(null);

  const sucursalesOptions =
    sucursales && sucursales.length > 0
      ? sucursales.map((sucursal) => ({
          value: sucursal.itemId,
          label: sucursal.titulo || sucursal.title,
        }))
      : [];

  const getFunctionToFilter = (filter, selected) => {
    if (filter === "motivo") {
      setMotivoValue(selected);
    }
    if (filter === "sucursal") {
      setSucursalValue(selected);
    }
  };

  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const handleDatesChange = (values, type) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    if (type === "fecha") {
      setFechaValue(fechaFormateada);
    }
  };

  const formik = useFormik({
    initialValues: {
      clientId,
      razonSocial,
      sucursalId: "",
      fecha: "",
      motivo: "",
      cliente: "",
    },

    onSubmit: async (values) => {
      const dataToCreateRelevo = {
        ...values,
        fecha: fechaValue,
        motivo: motivoValue ? motivoValue.value : null,
        sucursalId: sucursalValue ? sucursalValue.value : null,
      };

      try {
        if (!sucursalValue) {
          toast.error("El campo Sucursal es requerido");
          return;
        }
        if (!motivoValue) {
          toast.error("El campo Motivo es requerido");
          return;
        }

        const { message } = await createOrUpdateVisita(dataToCreateRelevo, dataToEdit && dataToEdit.id ? dataToEdit.id : null);
        toast.success(message);
        toggle();
        refreshVisitas();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      cliente: Yup.string().required("Este campo es requerido."),
    }),
  });

  useEffect(() => {
    if (dataToEdit && !isLoadingSucursales && sucursalesOptions.length > 0) {
      formik.setValues(dataToEdit);
      setFechaValue(dataToEdit.fecha);
      setMotivoValue({ value: dataToEdit.motivo, label: dataToEdit.motivo });
      setSucursalValue(sucursalesOptions.find((sucursal) => sucursal.value === dataToEdit.sucursalId));
    }
  }, [dataToEdit, isLoadingSucursales]);

  return (
    <>
      <BlurSpinner>
        <Container>
          <form onSubmit={formik.handleSubmit}>
            <div>
              <div className="d-flex flex-column justify-content-between align-items-start">
                <div className="w-100 mb-3">
                  <div>
                    <GridGroup>
                      <div className="mb-1">
                        <CustomLabel>Razon Social</CustomLabel>
                        <InputText type="text" id="razonSocial" disabled value={formik.values.razonSocial} />
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Sucursal</CustomLabel>
                        <LabSelect
                          id="sucursal"
                          name="sucursal"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={sucursalValue}
                          placeholder="Seleccionar"
                          isClearable
                          isLoading={isLoadingSucursales}
                          disabled={isLoadingSucursales || formik.isSubmitting}
                          options={sucursalesOptions}
                        />
                      </div>

                      <StylesDatePicker className="mb-1">
                        <CustomLabel htmlFor="fecha"> Fecha </CustomLabel>
                        <DatePicker
                          locale={locale}
                          showIcon
                          placeholder="fecha"
                          className="digits date-input"
                          dateFormat="YYYY-MM-DD"
                          onChange={(e) => handleDatesChange(e, "fecha")}
                          value={formatearFecha(fechaValue || fechaActual)}
                          selected={fechaValue ? new Date(fechaValue).setDate(new Date(fechaValue).getDate() + 1) : null}
                          maxDate={new Date()}
                        />
                      </StylesDatePicker>

                      <div className="mb-1">
                        <CustomLabel>Nombre y Apellido Cliente</CustomLabel>
                        <InputText
                          type="text"
                          id="cliente"
                          disabled={formik.isSubmitting}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.cliente}
                          maxLength={40}
                          placeholder={formik.errors.cliente && formik.touched.cliente ? formik.errors.cliente : null}
                          style={formik.errors.cliente && formik.touched.cliente ? { borderBottom: "1px solid red" } : null}
                        />
                      </div>

                      <div className="mb-1">
                        <CustomLabel>Motivo</CustomLabel>
                        <LabSelect
                          id="motivo"
                          name="motivo"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={motivoValue}
                          placeholder="Seleccionar"
                          isClearable
                          options={MotivosOptions}
                        />
                      </div>
                    </GridGroup>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <Button className="mr-2" size="sm" color="btn" type="button" onClick={() => toggle()}>
                  Cancelar
                </Button>
                <ButtonPrimary size="sm" type="submit" disabled={formik.isSubmitting}>
                  Guardar
                </ButtonPrimary>
              </div>
            </div>
          </form>
        </Container>
      </BlurSpinner>
    </>
  );
}
